import * as React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {useForm} from 'react-hook-form'
import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function Register() {
    let navigate = useNavigate();
    const classes = useStyles();
    const { handleSubmit} = useForm()

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">
                    Sign up
                </Typography>
                <form className={classes.form} noValidate
                      onSubmit={handleSubmit((data)=>
                          {
                              console.log(data)
                              navigate('/')
                          }
                      )}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        // inputRef={register}
                        required
                        fullWidth
                        id="userName"
                        // label="Username"
                        placeholder='Username'
                        name="username"
                        autoFocus
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        // inputRef={register}
                        required
                        fullWidth
                        id="email"
                        // label="Email Address"
                        placeholder='Email Address'
                        name="email"
                        autoComplete="email"
                        autoFocus
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        // inputRef={register}
                        required
                        fullWidth
                        name="password"
                        // label="Password"
                        placeholder='Password'
                        type="password"
                        id="password"
                        autoComplete="current-password"
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        // inputRef={register}
                        required
                        fullWidth
                        name="Confirm_password"
                        // label="Confirm Password"
                        placeholder='Confirm Password'
                        type="password"
                        id="Confirm_password"
                        autoComplete="current-password"
                    />
                    {/*<FormControlLabel*/}
                    {/*    control={*/}
                    {/*        <Controller as={Checkbox} control={control} name="remember" color="primary" defaultValue={false}/>}*/}
                    {/*    label="Remember me"*/}
                    {/*/>*/}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Register
                    </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link href="#" variant="body2">
                                Forgot password?
                            </Link>
                        </Grid>
                        <Grid item>
                            <RouterLink to='/auth' style={{ textDecoration: 'none'}}>

                                    {"All ready having an account? Sign in"}

                            </RouterLink>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </Container>
    );
}